import { render, staticRenderFns } from "./ChartsTab.vue?vue&type=template&id=ec333ea2&scoped=true&"
import script from "./ChartsTab.vue?vue&type=script&lang=js&"
export * from "./ChartsTab.vue?vue&type=script&lang=js&"
import style0 from "./ChartsTab.vue?vue&type=style&index=0&id=ec333ea2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec333ea2",
  null
  
)

export default component.exports